// 404 page — redirects to landing with friendly UI
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";
import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page introuvable · FlowMind AI";
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex flex-col">
      <PublicHeader />
      <section className="flex-1 flex items-center justify-center px-6 py-20" data-testid="not-found-page">
        <div className="max-w-lg text-center">
          <p className="font-mono text-sm tracking-widest text-zinc-400 mb-4">ERROR · 404</p>
          <h1 className="font-display text-6xl lg:text-7xl font-medium tracking-tighter mb-6">
            Page introuvable.
          </h1>
          <p className="text-lg text-zinc-600 mb-10">
            Cette page n'existe pas ou a été déplacée. Pas de panique — voici comment retrouver votre chemin.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link to="/">
              <Button size="lg" className="rounded-sm bg-black text-white hover:bg-zinc-800 h-12" data-testid="404-home-btn">
                <Home size={16} className="mr-2"/> Retour à l'accueil
              </Button>
            </Link>
            <Link to="/demo">
              <Button size="lg" variant="outline" className="rounded-sm h-12" data-testid="404-demo-btn">
                <ArrowLeft size={16} className="mr-2"/> Tester la démo
              </Button>
            </Link>
          </div>
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
